/**
 * Reset the authenticated shell scrollport after a route change.
 * Pages scroll `#main-content`, not `window` — window-only reset leaves the
 * user halfway down the previous page on mobile web.
 *
 * Browser ESM entry. Keep the body aligned with `resetRouteScroll.cjs` (Jest).
 *
 * @param {{
 *   main?: { scrollTop: number } | null,
 *   windowObj?: { scrollTo?: (x: number, y: number) => void } | null,
 * }} [opts]
 */
export function resetRouteScroll(opts = {}) {
  const main =
    opts.main !== undefined
      ? opts.main
      : typeof document !== 'undefined'
        ? document.getElementById('main-content')
        : null;
  if (main) main.scrollTop = 0;

  const win =
    opts.windowObj !== undefined
      ? opts.windowObj
      : typeof window !== 'undefined'
        ? window
        : null;
  if (win && typeof win.scrollTo === 'function') {
    win.scrollTo(0, 0);
  }
}
